import { useEffect, useState } from "react";
import ParcelOrderService from "../../services/parcel-order.service";
import { EmptyState } from "../../components/EmptyState";
import OrderCardTable from "../../components/OrderCardTable";

export const DriverDashBoard = () => {
	const [OrdersState, setOrderState] = useState({ orders: [] });
	const { orders } = OrdersState;

	useEffect(() => {
		const fetchOrders = async () => {
			try {
				const data = await ParcelOrderService.parcel_order_fulfillments();
				setOrderState((prev) => ({ ...prev, orders: data }));
			} catch (error) {
				console.error("Error fetching orders:", error);
			}
		};
		fetchOrders();
	}, []);

	return (
		<div className="w-full min-h-screen flex flex-col bg-gradient-to-br from-cyan-50 to-fuchsia-100">
			<div className="px-4 py-6 lg:px-20 lg:py-8 flex flex-col gap-5">

				{/* Page Header */}
				<div>
					<h1 className="text-2xl md:text-4xl font-extrabold text-gray-800">Dashboard</h1>
					<p className="text-gray-500 mt-1 text-sm">Manage your active and completed deliveries</p>
				</div>

				{/* Pending Deliveries */}
				<section className="flex flex-col gap-3">
					<div className="flex items-center gap-3">
						<h2 className="text-lg md:text-2xl font-bold text-gray-700">Pending Deliveries</h2>
						{orders?.upcoming_parcels?.length > 0 && (
							<span className="bg-purple-100 text-purple-700 text-xs font-semibold px-2.5 py-1 rounded-full">
								{orders.upcoming_parcels.length}
							</span>
						)}
					</div>
					{orders?.upcoming_parcels?.length > 0
						? orders.upcoming_parcels.map((order, i) => <OrderCardTable key={i} order={order} />)
						: <EmptyState />}
				</section>

				{/* Past Deliveries */}
				<section className="flex flex-col gap-3">
					<div className="flex items-center gap-3">
						<h2 className="text-lg md:text-2xl font-bold text-gray-700">Past Deliveries</h2>
						{orders?.past_parcels?.length > 0 && (
							<span className="bg-gray-100 text-gray-600 text-xs font-semibold px-2.5 py-1 rounded-full">
								{orders.past_parcels.length}
							</span>
						)}
					</div>
					{orders?.past_parcels?.length > 0
						? orders.past_parcels.map((order, i) => <OrderCardTable key={i} order={order} />)
						: <EmptyState />}
				</section>
			</div>
		</div>
	);
};
